import { SpaceScope } from "~/hooks/useScope";
import { Space } from "~/lib/types";
import { useLoadSpaceQuery } from "~/operations";

interface Props {
  space: Space | SpaceScope;
}

export function useSpaceSettings({ space }: Props) {
  const { data: spaceDataFromSpaceId } = useLoadSpaceQuery({
    variables: { spaceMrn: space.mrn },
    skip: !space.mrn,
  });

  return {
    pvcIsEnabled:
      !!spaceDataFromSpaceId?.space?.settings
        ?.platformVulnerabilityConfiguration.enable,
    exceptionsAllowIndefiniteValidUntil:
      !!spaceDataFromSpaceId?.space?.settings?.exceptionsConfiguration
        ?.allowIndefiniteValidUntil,
    exceptionsAllowSelfApproval:
      !!spaceDataFromSpaceId?.space?.settings?.exceptionsConfiguration
        ?.allowSelfApproval,
  };
}
